export default "__VITE_ASSET__C_L1rYEt__"